import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import VueSweetalert2 from 'vue-sweetalert2';
import { Dropdown } from "vue-simple-search-dropdown";
import 'sweetalert2/dist/sweetalert2.min.css';
//Chart js css
require('@/assets/js/plugins/chartjs.min.js')

import { VueSelect } from "vue-select";

/* import jQuery/$ for plugins */
import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery

import { FontAwesomeIcon } from './plugins/font-awesome'

import setupInterceptors from './services/setupInterceptors'


setupInterceptors(store)


createApp(App)
  .use(router)
  .use(store)
  .use(VueSweetalert2)
  .component("v-select", VueSelect)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app")
